var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcComplete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1262_16020)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6624 1.8418C6.06243 1.8418 2.3291 5.57513 2.3291 10.1751C2.3291 14.7751 6.06243 18.5085 10.6624 18.5085C15.2624 18.5085 18.9958 14.7751 18.9958 10.1751C18.9958 5.57513 15.2624 1.8418 10.6624 1.8418ZM8.4041 13.7501L5.41243 10.7585C5.08743 10.4335 5.08743 9.90846 5.41243 9.58346C5.73743 9.25846 6.26243 9.25846 6.58743 9.58346L8.99577 11.9835L14.7291 6.25013C15.0541 5.92513 15.5791 5.92513 15.9041 6.25013C16.2291 6.57513 16.2291 7.10013 15.9041 7.42513L9.5791 13.7501C9.26243 14.0751 8.7291 14.0751 8.4041 13.7501Z",
    fill: "#05CD99"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1262_16020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.662109 0.175781)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcComplete);
export default __webpack_public_path__ + "static/media/ic_complete.46c772062fd90baf2a05ab2d4c0c8433.svg";
export { ForwardRef as ReactComponent };